export default function getFirstSTringChars(string, nb) {
  return string.slice(0, nb);
}
